export const CUSTOM_FIELD_TYPE = {
  TEXT: 'text',
  DATE: 'date',
  USER: 'user',
  NUMBER: 'number',
  DROPDOWN: 'dropdown'
}
export const CUSTOM_FIELD_TYPE_KEY = {
  [CUSTOM_FIELD_TYPE.TEXT]: 'textValue',
  [CUSTOM_FIELD_TYPE.DATE]: 'dateValue',
  [CUSTOM_FIELD_TYPE.USER]: 'userId',
  [CUSTOM_FIELD_TYPE.NUMBER]: 'numberValue',
  [CUSTOM_FIELD_TYPE.DROPDOWN]: 'dropdownOptionId'
}
export const FIELD_LABEL = {
  [CUSTOM_FIELD_TYPE.TEXT]: 'Text',
  [CUSTOM_FIELD_TYPE.DATE]: 'Date',
  [CUSTOM_FIELD_TYPE.USER]: 'Assignee',
  [CUSTOM_FIELD_TYPE.NUMBER]: 'Number',
  [CUSTOM_FIELD_TYPE.DROPDOWN]: 'Dropdown'
}
export const CUSTOM_FIELD_LABEL = FIELD_LABEL
